"use client";

import React from "react";
// import UpdatedHeader from "@/components/common/UpdatedHeader";
import QuickContact from "@/components/common/QuickContact";
import BridgeBannerMob from "@/components/pageComponent/bridge-course/mobBanner";
import MobBridgeEligibilty from "@/components/pageComponent/bridge-course/mobBridge-eligibility";
import MobBridgeProgram from "@/components/pageComponent/bridge-course/mobBridge-program";
import MobBridgeTable from "@/components/pageComponent/bridge-course/mobBridge-table";
import MobBridgeUni from "@/components/pageComponent/bridge-course/mobBridge-uni";
import BridgeContact from "@/components/pageComponent/bridge-course/bridge-contact";
import EventTicker from "@/components/common/EventTicker";
import GlobalHeaderNew from "@/components/common/newCommonComponent/GlobalHeaderNew";
import GlobalFooter from "@/components/common/newCommonComponent/GlobalFooter";
// import CallNowButton from "@/components/common/callNowButton";

export interface FormProps {
  submitButtonName: string;
  formTitle: string | false;
  showWebinar: boolean;
  popupName?: boolean;
  PopupId?: number;
  popupUserId?: null | number;
}

const MobilePage: React.FC = () => {
  return (
    <div className="w-full  bg-white">
      <div className="w-full">
        <EventTicker />
      </div>
      <GlobalHeaderNew />
      <BridgeBannerMob />
      <MobBridgeEligibilty />
      <MobBridgeProgram />
      <MobBridgeTable />
      <MobBridgeUni />
      <BridgeContact />
      <GlobalFooter />
      <QuickContact />
      {/* <CallNowButton /> */}
    </div>
  );
};

export default MobilePage;
